import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { ApplicationDomainBoundary } from "~/components/application-domain-boundary";
import { ApplicationDomain } from "~/models/dto";

import { selectAllSearchParams } from "../app/state/route/RouteSelectors";
import { queryUIConfig } from "../queries";
import { useQuery } from "../queries/react-query";

export const RootApplcationDomainProvider = ({ children }: { children: React.ReactNode }) => {
	const { domain: applicationDomainSearchParam } = useSelector(selectAllSearchParams);
	const { data } = useQuery(queryUIConfig);
	const configuredApplicationDomains = data?.applicationDomains;

	const applicationDomain =
		applicationDomainSearchParam != null && configuredApplicationDomains?.includes(applicationDomainSearchParam)
			? applicationDomainSearchParam
			: (configuredApplicationDomains?.[0] ?? ApplicationDomain.Observability);

	useEffect(() => {
		document.documentElement.dataset.mode = applicationDomain;
	}, [applicationDomain]);

	// TODO: Replace with RemoteData monad
	return (
		<ApplicationDomainBoundary applicationDomain={applicationDomain} wrapChildren={false}>
			{children}
		</ApplicationDomainBoundary>
	);
};
